import { Children, cloneElement, ReactElement } from "react";
import { useModal } from "../ModalRoot/ModalRoot";

interface ModalTriggerProps {
  children: ReactElement;
}

const ModalTrigger = ({ children }: ModalTriggerProps) => {
  const { setOpen } = useModal();
  return Children.map(children, (child) =>
    cloneElement(child, {
      onClick: (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        setOpen(true);
      },
    }),
  );
};

export default ModalTrigger;
